"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertProductToDataGridRow = exports.getStrategyAttributeLabels = exports.getStrategyAttributeLabelsFromFields = exports.getOriginalAttributeColumnIds = exports.getOriginalAttributeColumnIdsFromFields = void 0;
const graphql_1 = require("../../../../../../__generated__/graphql");
const product_1 = require("../../../../../client/product");
const product_table_1 = require("../../../../../common/product-table");
const table_columns_1 = require("../../../../../common/table-columns");
const attributes_1 = require("../../../../../constants/attributes");
const utils_1 = require("../../../../../utils");
/**
 * Get original attribute column ids (non AI enriched and non-measure)
 * @param columns - list of columns
 * @returns list of original attribute column ids
 */
const getOriginalAttributeColumnIdsFromFields = (columnFields) => columnFields
    .filter((field) => {
    const { dataMeta } = (0, table_columns_1.parseColumnId)(field);
    return !(dataMeta === null || dataMeta === void 0 ? void 0 : dataMeta.isAIEnriched) && !(dataMeta === null || dataMeta === void 0 ? void 0 : dataMeta.isMeasure);
});
exports.getOriginalAttributeColumnIdsFromFields = getOriginalAttributeColumnIdsFromFields;
const getOriginalAttributeColumnIds = (columns) => (0, exports.getOriginalAttributeColumnIdsFromFields)(columns.map(({ field }) => field));
exports.getOriginalAttributeColumnIds = getOriginalAttributeColumnIds;
/**
 * Get strategy attribute labels (AI enriched, non-measure)
 * @param columns - list of columns
 * @returns list of strategy attribute labels
 */
const getStrategyAttributeLabelsFromFields = (columnFields) => columnFields
    .filter((field) => {
    const { dataMeta } = (0, table_columns_1.parseColumnId)(field);
    return (dataMeta === null || dataMeta === void 0 ? void 0 : dataMeta.isAIEnriched) && !(dataMeta === null || dataMeta === void 0 ? void 0 : dataMeta.isMeasure);
})
    .map((field) => (0, table_columns_1.parseColumnId)(field).label);
exports.getStrategyAttributeLabelsFromFields = getStrategyAttributeLabelsFromFields;
const getStrategyAttributeLabels = (columns) => (0, exports.getStrategyAttributeLabelsFromFields)(columns.map(({ field }) => field));
exports.getStrategyAttributeLabels = getStrategyAttributeLabels;
const convertProductToDataGridRow = (products, originalAttributeColumnIds, strategyAttributeLabels, sortColumn, assumeUnknownWithoutValidation = false) => {
    const originalAttributeColumnIdsSet = new Set(originalAttributeColumnIds);
    const strategyAttributeLabelsValue = strategyAttributeLabels !== null && strategyAttributeLabels !== void 0 ? strategyAttributeLabels : [];
    const validStatusesSet = new Set(product_1.VALID_STATUSES);
    return products.map((_a) => {
        var _b, _c;
        var { labels, measures, categories, strategyAttributeLabels: strategyAttributeLabelsFromValidation } = _a, product = __rest(_a, ["labels", "measures", "categories", "strategyAttributeLabels"]);
        const productMetadata = product.productMetadata;
        const { lastAttributeUpdatedAt, lastEditedBy } = productMetadata;
        const { edges = [] } = labels !== null && labels !== void 0 ? labels : {};
        const productAttributes = {};
        const originalUrls = [];
        edges.forEach(({ node }) => {
            const { label, value, status, origin, } = node;
            const isValid = originalAttributeColumnIdsSet.has(label) || validStatusesSet.has(status);
            if (isValid) {
                const values = productAttributes[label];
                if (values) {
                    values.push(value);
                }
                else {
                    productAttributes[label] = [value];
                }
            }
            if (label === 'url' && origin === graphql_1.ProductAttributeOrigin.Original) {
                originalUrls.push(value);
            }
        });
        // Prefer ORIGINAL-origin 'url' label for Product Page URL.
        if (productAttributes[attributes_1.PRODUCT_PAGE_URL_LABEL] && originalUrls.length > 0) {
            productAttributes[attributes_1.PRODUCT_PAGE_URL_LABEL] = originalUrls;
        }
        const strategyAttributeLabelsSet = strategyAttributeLabelsFromValidation
            ? new Set(strategyAttributeLabelsFromValidation)
            : undefined;
        // Add Unknown when label validation confirms strategy membership.
        // For terminal node views we can skip validation payload and still treat missing strategy values as Unknown.
        if (strategyAttributeLabelsValue.length > 0) {
            strategyAttributeLabelsValue.forEach((label) => {
                if (productAttributes[label]) {
                    return;
                }
                if ((strategyAttributeLabelsSet === null || strategyAttributeLabelsSet === void 0 ? void 0 : strategyAttributeLabelsSet.has(label)) || (!strategyAttributeLabelsSet && assumeUnknownWithoutValidation)) {
                    productAttributes[label] = [attributes_1.SpecialAttributeValue.Unknown];
                }
            });
        }
        const sortColumnValues = sortColumn ? productAttributes[sortColumn.key] : undefined;
        if (sortColumn && (sortColumnValues === null || sortColumnValues === void 0 ? void 0 : sortColumnValues.length) > 1) {
            productAttributes[sortColumn.key] = (0, utils_1.sortLabelValues)(sortColumnValues, sortColumn.direction);
        }
        const productMeasures = {};
        measures === null || measures === void 0 ? void 0 : measures.edges.forEach(({ node }) => {
            const { dimension, value } = node;
            const values = productMeasures[dimension];
            if (values) {
                values.push(value);
            }
            else {
                productMeasures[dimension] = [value];
            }
        });
        const classificationProductType = (_c = (_b = categories.edges) === null || _b === void 0 ? void 0 : _b[0].node) === null || _c === void 0 ? void 0 : _c.category;
        return Object.assign(Object.assign({}, product), { [product_table_1.LABEL_PATH]: productAttributes, [product_table_1.MEASURE_PATH]: productMeasures, [attributes_1.CustomProductAttributes.ClassificationProductType]: classificationProductType, [attributes_1.CustomProductAttributes.LastAttributeUpdatedAt]: lastAttributeUpdatedAt, [attributes_1.CustomProductAttributes.LastEditedBy]: lastEditedBy });
    });
};
exports.convertProductToDataGridRow = convertProductToDataGridRow;
